const Delete = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.835 5a1.5 1.5 0 0 1 1.415-1h3.5a1.5 1.5 0 0 1 1.415 1H18.5a.5.5 0 0 1 0 1H18v11.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 6 17.5V6h-.5a.5.5 0 0 1 0-1zM7 6v11.5A1.5 1.5 0 0 0 8.5 19h7a1.5 1.5 0 0 0 1.5-1.5V6z"
      clipRule="evenodd"
    />
  </>
)
export default Delete
